<template>
  <div>
    <div id="sidebar" :class="`${estadoMenu ? 'active' : 'hidden'}`">
      <div class="sidebarHeader">
        <span class="setaVoltar" @click="fecharMenu">Voltar</span>
      </div>
      <div class="sidebarBody">
        <ul>
          <li @click="mudarRota('home')">
            <p>Ínicio</p>
          </li>
          <li @click="mudarRota('seguranca')">
            <p>O Índice de Segurança Hídrica (ISH)</p>
          </li>
          <li @click="mudarRota('construcao')">
            <p>A construção</p>
          </li>
          <li @click="mudarRota('programa')">
            <p>O Programa</p>
          </li>
          <li @click="mudarRota('intervencao')">
            <p>As Intervenções</p>
          </li>
          <li @click="mudarRota('monitoramento')">
            <p>O Monitoramento</p>
          </li>
        </ul>
      </div>
      <div class="sidebarFooter">
        
        <div class="bandeiras">
          <p>PDF:</p>
          <a href="http://arquivos.ana.gov.br/pnsh/pnsh.pdf" target="_blank">
            <img src="@/assets/brasil.svg" target="_blank" />
          </a>
          <a
            href="/pdf/ingles.pdf" target="_blank" 
          >
            <img src="@/assets/england.svg" />
          </a>
          <a
            href="/pdf/espanhol.pdf" target="_blank" 
          >
            <img src="@/assets/espanha.svg" />
          </a>
        </div>
        <ul>
          <li>
            <a href="https://www.facebook.com/anagovbr/">
              <img src="@/assets/icon-face.png" alt />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/13058996/">
              <img src="@/assets/icon_link.png" alt />
            </a>
          </li>
          <li>
            <a href="https://twitter.com/ANAgovbr">
              <img src="@/assets/icon_twitter.png" alt />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/anagovbr/">
              <img src="@/assets/icon_instagram.png" alt />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCLLjIf0AjdwQAtp3hDmrhZQ">
              <img src="@/assets/you.png" alt />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div id="overlay" :class="`${estadoMenu ? 'active' : 'hidden'}`" @click="fecharMenu"></div>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      estadoMenu: state => state.Layout.menu
    })
  },

  methods: {
    ...mapActions({
      toggleMenu: "Layout/toggleMenu",
      setModal: "Layout/setModalAtiva"
    }),

    fecharMenu() {
      this.toggleMenu(false);
    },

    mudarRota(rota) {
      this.toggleMenu(false);
      this.$router.push(rota);
    },

    beforeRouteUpdate(to, from, next) {
      this.fecharMenu();
    },

    atualizarModal(item) {
      this.setModal(item);
    }
  }
};
</script>


<style lang="scss" scoped>
.bandeiras {
  display: flex;
  align-items: center;
  p {
    color: #ffffff;
  }
  img {
    padding-left: 15px;
  }
}
#sidebar {
  display: none;

  @include media_tablet() {
    display: flex;
  }

  transform: translateX(-150);

  &.active {
    display: flex;
    transform: translateX(0vw);
    transition: all 500ms ease;
  }

  &.hidden {
    transform: translateX(-150vw);
    transition: all 500ms ease-out;
  }

  @include media_tablet() {
    display: flex;
    flex-direction: column;
    position: fixed;
    color: #fff;
    top: 0;
    width: 90vw;
    height: 100vh;
    z-index: 99999;
    background-color: #344789;
    border-radius: 0 30px 30px 0;
    padding-left: 22px;
  }

  .sidebarHeader {
    height: 20vh;

    .setaVoltar {
      background-image: url(../assets/seta-menu-green.svg);
      background-repeat: no-repeat;
      color: transparent;
      height: 30px;
      width: 30px;
      position: absolute;
      top: 15px;
    }
  }

  .sidebarBody {
    height: auto;

    ul {
      li {
        margin-bottom: 50px;
        p {
          color: #fff;
          font-size: 16px;

          @include media_mobile_small() {
            font-size: 14px;
          }
        }
      }
    }
  }

  .sidebarFooter {
    a {
      color: #ffffff;
    }

    .download-pdf {
      display: block;
      margin-bottom: 23px;
      font-size: 14px;
      position: relative;
      padding-left: 25px;
      font-family: "rubik_mediumregular";

      &::after {
        content: "";
        background-image: url(../assets/icon_downloand_menu.svg);
        background-repeat: no-repeat;
        position: absolute;
        left: 0;
        height: 20px;
        width: 20px;
        top: -5px;
      }
    }

    ul {
      display: flex;
      justify-content: space-between;
      width: 55%;
      margin-top: 20px;
      margin-bottom: 30px;

      li {
        cursor: pointer;
      }
    }
  }
}

#overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9;
  cursor: pointer;

  &.active {
    display: block;
    transform: translateX(0vw);
    transition: all 500ms ease;
  }

  &.hidden {
    display: none;
    transform: translateX(-150vw);
    transition: all 500ms ease-out;
  }
}
</style>
